// Same values as WebshopCopyrightAcknowledgement on the PHP side, whose
// script in <head> hides the previews before this code loads.
export const STORAGE_KEY = "epmsCopyrightAcknowledgement";
export const PENDING_CLASS = "epms-copyright-acknowledgement-pending";
export const READY_FLAG = "epmsCopyrightAcknowledgementReady";
/** Sent on window when the end user's subjects change without a page load. */
export const SUBJECTS_EVENT = "epms:copyright-acknowledgement-subjects";
/**
 * localStorage throws in some private modes, and an old or broken value
 * fails to parse; both count as nothing accepted.
 */
const readAccepted = () => {
    var _a;
    try {
        const value = JSON.parse((_a = window.localStorage.getItem(STORAGE_KEY)) !== null && _a !== void 0 ? _a : "null");
        if (typeof value === "object" &&
            value !== null &&
            "version" in value &&
            "subjects" in value &&
            typeof value.version === "string" &&
            Array.isArray(value.subjects)) {
            return { version: value.version, subjects: value.subjects };
        }
    }
    catch (_b) {
        // Nothing accepted.
    }
    return null;
};
/** Accepted when the version matches and no subject is new. */
export const isAccepted = (version, subjects) => {
    const accepted = readAccepted();
    return ((accepted === null || accepted === void 0 ? void 0 : accepted.version) === version &&
        subjects.every((subject) => accepted.subjects.includes(subject)));
};
/**
 * Keeps the subjects accepted earlier for the same version, as another end
 * user can share the browser.
 */
export const accept = (version, subjects) => {
    const accepted = readAccepted();
    const earlier = (accepted === null || accepted === void 0 ? void 0 : accepted.version) === version ? accepted.subjects : [];
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
            version,
            subjects: [...new Set([...earlier, ...subjects])],
        }));
    }
    catch (_a) {
        // Accepted for this page only.
    }
};
export const setPreviewsHidden = (hidden) => {
    document.documentElement.classList.toggle(PENDING_CLASS, hidden);
};
/** The end user's subjects when the page loaded, from the webshop config. */
export const getInitialSubjects = () => {
    var _a, _b;
    const user = (_a = window.NTLF_CONFIG) === null || _a === void 0 ? void 0 : _a.user;
    return (_b = user === null || user === void 0 ? void 0 : user.copyrightAcknowledgementSubjects) !== null && _b !== void 0 ? _b : [];
};
/**
 * Tells the gate about the end user's subjects after a login or a new code
 * that does not load a new page. Does nothing without a list, as for the
 * anonymous user.
 */
export const reportSubjects = (subjects) => {
    if (subjects) {
        window.dispatchEvent(new CustomEvent(SUBJECTS_EVENT, { detail: subjects }));
    }
};
